import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function QuoteSection() {
  return (
    <section id="why" className="bg-lima-cream text-lima-ink px-5 md:px-10 py-14 md:py-32 border-b border-black/10" data-testid="quote-section">
      <div className="flex items-center justify-between mb-8 md:mb-16">
        <span className="hidden md:block font-mono2 text-xs tracking-[0.25em] text-black/50 underline underline-offset-4 decoration-black/30">
          THE GAP BETWEEN TUTORIALS AND A REAL SET
        </span>
      </div>
      <motion.h2
        initial={{ opacity: 0, y: 40, scale: 1.03, filter: "blur(16px)" }}
        whileInView={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-5xl"
      >
        Filmmaking is not a collection of software. It is a{" "}
        <span className="font-serifit font-normal text-[#3a3a36]">way of seeing, thinking and working.</span>
      </motion.h2>
      <div className="mt-14 md:mt-20 pt-8 border-t border-black/15 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <p className="max-w-xl text-sm md:text-base text-black/60 leading-relaxed">
          We teach the complete journey — not isolated tools. You learn why a shot works, how a crew communicates,
          what happens when a plan changes, and how an idea survives all the way to the final export.
        </p>
        <button
          onClick={() => scrollToId("#how")}
          data-testid="philosophy-link"
          className="shrink-0 font-semibold text-sm flex items-center gap-2 border-b-2 border-lima-ink pb-1 hover:text-lima-blue hover:border-lima-blue transition-colors duration-200"
        >
          Our learning philosophy <ArrowRight size={15} />
        </button>
      </div>
    </section>
  );
}
